var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewArrowGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.202081 1.14613C-0.0727923 1.44675 -0.0727923 1.93423 0.202081 2.23485L4.42527 6.85398C4.70013 7.15461 5.14582 7.15461 5.42068 6.85398L9.64386 2.23485C9.91872 1.93423 9.91872 1.44675 9.64386 1.14613C9.369 0.845497 8.92331 0.845497 8.64845 1.14613L4.92297 5.22089L1.1975 1.14613C0.922619 0.845497 0.476961 0.845497 0.202081 1.14613Z",
    fill: "#00BA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowGreen);
export default __webpack_public_path__ + "static/media/NewArrowGreen.b031c1468180c51e6e5db43ecedd9a6f.svg";
export { ForwardRef as ReactComponent };